/**
 * Search functionality for header search bar with live predictions
 */

function initSearch() {
  const searchIcon = document.querySelector(".js-open-search");
  const searchForm = document.querySelector(".js-search-form");
  const searchInput = document.querySelector(".header__search-input");
  const closeButton = document.querySelector(".js-close-search");
  let predictionsTimeout;

  if (!searchInput || !searchForm) return;

  // Mobile: toggle search form on icon click
  if (searchIcon) {
    searchIcon.addEventListener("click", (e) => {
      e.preventDefault();
      searchForm.classList.toggle("search-open");
      if (searchForm.classList.contains("search-open")) {
        setTimeout(() => searchInput.focus(), 0);
      }
    });
  }

  // Close button for mobile
  if (closeButton) {
    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      searchForm.classList.remove("search-open");
      clearPredictions();
    });
  }

  // Live search as user types
  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      const query = e.target.value.trim();

      clearTimeout(predictionsTimeout);

      if (query.length > 0) {
        // Debounce the search to avoid too many requests
        predictionsTimeout = setTimeout(() => {
          fetchPredictions(query);
        }, 200);
      } else {
        clearPredictions();
      }
    });

    // Handle Enter key to submit form
    searchInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        searchForm.submit();
      }
    });
  }

  // Close predictions when clicking outside
  document.addEventListener("click", (e) => {
    if (!searchForm.contains(e.target) && !searchIcon.contains(e.target)) {
      clearPredictions();
    }
  });

  // Handle Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      clearPredictions();
      searchForm.classList.remove("search-open");
    }
  });

  function fetchPredictions(query) {
    // Use Shopify Predictive Search API to fetch products, pages, and articles
    fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        query,
      )}&resources[type]=product,page,article&resources[limit]=5&resources[options][fields]=title,product_type`,
    )
      .then((response) => response.json())
      .then((data) => {
        displayPredictions(data, query);
      })
      .catch((error) => {
        console.error("Error fetching predictions:", error);
      });
  }

  function displayPredictions(data, query) {
    let predictionsDiv = document.querySelector(".header__search-predictions");

    if (!predictionsDiv) {
      predictionsDiv = document.createElement("div");
      predictionsDiv.className = "header__search-predictions";
      searchForm.appendChild(predictionsDiv);
    }

    predictionsDiv.innerHTML = "";

    const products = data.resources?.results?.products || [];
    const pages = data.resources?.results?.pages || [];
    const articles = data.resources?.results?.articles || [];

    const totalResults = products.length + pages.length + articles.length;

    if (totalResults === 0) {
      predictionsDiv.innerHTML =
        '<div class="search-prediction-item search-prediction-empty">No results found for "' +
        escapeHtml(query) +
        '"</div>';
      predictionsDiv.style.display = "block";
      return;
    }

    const fragment = document.createDocumentFragment();

    // Add Products section
    if (products.length > 0) {
      const productsSection = document.createElement("div");
      productsSection.className = "search-predictions-section";

      const productsHeader = document.createElement("div");
      productsHeader.className = "search-predictions-header";
      productsHeader.textContent = "Products";
      productsSection.appendChild(productsHeader);

      products.forEach((product) => {
        const item = document.createElement("a");
        item.href = product.url;
        item.className = "search-prediction-item";

        let imageHtml = "";
        const productImg = product.featured_image || product.image;
        if (productImg && productImg.url) {
          imageHtml = `<img src="${productImg.url}" alt="${escapeHtml(
            product.title,
          )}" class="search-prediction-image">`;
        }

        item.innerHTML = `
          ${imageHtml}
          <div class="search-prediction-content">
            <div class="search-prediction-title">${escapeHtml(
              product.title,
            )}</div>
            ${
              product.product_type
                ? `<div class="search-prediction-type">${escapeHtml(
                    product.product_type,
                  )}</div>`
                : ""
            }
          </div>
        `;

        productsSection.appendChild(item);
      });

      fragment.appendChild(productsSection);
    }

    // Add Pages section
    if (pages.length > 0) {
      const pagesSection = document.createElement("div");
      pagesSection.className = "search-predictions-section";

      const pagesHeader = document.createElement("div");
      pagesHeader.className = "search-predictions-header";
      pagesHeader.textContent = "Pages";
      pagesSection.appendChild(pagesHeader);

      const pageIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>`;

      pages.forEach((page) => {
        const item = document.createElement("a");
        item.href = page.url;
        item.className = "search-prediction-item";

        item.innerHTML = `
          <span class="search-prediction-icon">${pageIconSvg}</span>
          <div class="search-prediction-content">
            <div class="search-prediction-title">${escapeHtml(page.title)}</div>
            <div class="search-prediction-type">Page</div>
          </div>
        `;

        pagesSection.appendChild(item);
      });

      fragment.appendChild(pagesSection);
    }

    // Add Articles section
    if (articles.length > 0) {
      const articlesSection = document.createElement("div");
      articlesSection.className = "search-predictions-section";

      const articlesHeader = document.createElement("div");
      articlesHeader.className = "search-predictions-header";
      articlesHeader.textContent = "Articles";
      articlesSection.appendChild(articlesHeader);

      articles.forEach((article) => {
        const item = document.createElement("a");
        item.href = article.url;
        item.className = "search-prediction-item";

        let articleImageHtml = "";
        const articleImg = article.image || article.featured_image;
        if (articleImg && articleImg.url) {
          articleImageHtml = `<img src="${articleImg.url}" alt="${escapeHtml(article.title)}" class="search-prediction-image">`;
        }

        item.innerHTML = `
          ${articleImageHtml}
          <div class="search-prediction-content">
            <div class="search-prediction-title">${escapeHtml(article.title)}</div>
            <div class="search-prediction-type">Article</div>
          </div>
        `;

        articlesSection.appendChild(item);
      });

      fragment.appendChild(articlesSection);
    }

    predictionsDiv.appendChild(fragment);
    predictionsDiv.style.display = "block";
  }

  function clearPredictions() {
    const predictionsDiv = document.querySelector(
      ".header__search-predictions",
    );
    if (predictionsDiv) {
      predictionsDiv.style.display = "none";
      predictionsDiv.innerHTML = "";
    }
  }

  function escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}

// Initialize search when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSearch);
} else {
  initSearch();
}

export { initSearch };
